// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__gaG4q","validationTips":"StatementDescriptor_validationTips__4To-X"};